import { CLIENT_ENV } from '@/config/configuration';
import { trackNewError } from './error';
import { getCookieByName } from './cookies';

enum EventsToTrack {
  ADD_TO_CART = 'Add To Cart',
  INITIATE_CHECKOUT = 'InitiateCheckout',
  PURCHASE = 'Purchase',
}
declare const fbq: any;
export type MetaPixelProduct = {
  value: number | string;
  currency: string;
  content_ids: string;
  content_type: string;
  content_name: string;
  content_category: string;
};

// export const trackEvent = <T extends Record<string, any>>(event: string, parameters: T) => {
//   if (canTrackEvents()) {
//     return fbq('track', event, parameters);
//   }
// };

export const trackAddToCartEvent = (data: MetaPixelProduct) => {
  if (canTrackEvents()) {
    return fbq('track', EventsToTrack.ADD_TO_CART, data);
  }
};

export const trackInitiateCheckout = (data: MetaPixelProduct) => {
  if (canTrackEvents()) {
    return fbq('track', EventsToTrack.INITIATE_CHECKOUT, data);
  }
};

export const canTrackEvents = () => {
  if (typeof fbq === 'undefined') {
    console.warn('Meta PIXEL not initialized!');
  }

  return typeof fbq !== 'undefined' && CLIENT_ENV().NODE_ENV === 'production' && CLIENT_ENV().NEXT_PUBLIC_ENV === 'production';
};

const URL =
  'https://graph.facebook.com/v19.0/737221764804423/events?access_token=EAAH6lWROWDEBANuzHwXuRZBty8nDgLyaxhZCXBnIytz3sp6GH1Jj6OU8dLcpuy3JFq6VMlEBDl9vcQ2YvTA6BQntW00i8ZAD6QsmPUZCkZABTvcwPDTeVYwDMMax7dR5ZChJ3Ns9LsZBgq1HLkTHts4DujjHwpqesME37ul5OQPI5ZBnbsI9vtyby67BZCun6PCoZD';

export interface TrackPurchaseParams {
  userEmail: string;
  price: number;
  service: string;
  userId?: string;
}

export const trackPurchase = async (params: TrackPurchaseParams) => {
  const envs = CLIENT_ENV();
  if (envs.NODE_ENV === 'production' && envs.NEXT_PUBLIC_ENV === 'production') {
    const fbcValue = getCookieByName('_fbc');
    const fbpValue = getCookieByName('_fbp');

    // Get user agent from browser
    const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';

    // Hash the email for privacy compliance
    const hashedEmail = await hashEmail(params.userEmail);

    const eventData = {
      data: [
        {
          event_name: 'Purchase',
          event_time: Math.floor(Date.now() / 1000),
          event_source_url: typeof window !== 'undefined' ? window.location.href : '',
          user_data: {
            fbc: fbcValue || '',
            fbp: fbpValue || '',
            external_id: params.userId || '',
            em: hashedEmail,
            client_user_agent: userAgent,
          },
          custom_data: {
            value: params.price,
            currency: 'EUR',
            content_ids: [params.service],
            content_type: 'product',
            content_name: params.service,
          },
        },
      ],
    };

    try {
      const response = await fetch(URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(eventData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Facebook Pixel event sent successfully:', data);
    } catch (error) {
      console.error('Facebook Pixel event failed:', error);
      trackNewError(error instanceof Error ? error.message : String(error));
    }
  }
};

// Proper email hashing function for Facebook Pixel using SHA256
const hashEmail = async (email: string): Promise<string> => {
  try {
    const normalizedEmail = email.toLowerCase().trim();

    // Check if crypto.subtle is available (modern browsers)
    if (typeof crypto !== 'undefined' && crypto.subtle) {
      const encoder = new TextEncoder();
      const data = encoder.encode(normalizedEmail);
      const hashBuffer = await crypto.subtle.digest('SHA-256', data);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
      return hashHex;
    } else {
      // Fallback for older browsers or environments without crypto.subtle
      console.warn('crypto.subtle not available, using simple hash fallback');
      return btoa(normalizedEmail).replace(/[^a-zA-Z0-9]/g, '');
    }
  } catch (error) {
    console.error('Error hashing email:', error);
    return '';
  }
};
